import { useState, useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const Products = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', label: 'All Products' },
    { id: 'scalp', label: 'Scalp Care' },
    { id: 'repair', label: 'Hair Repair' },
    { id: 'styling', label: 'Styling' },
    { id: 'color', label: 'Color Care' }
  ];

  const brands = [
    {
      id: 1,
      name: 'Kérastase',
      category: 'scalp',
      image: 'https://public.readdy.ai/ai/img_res/7466a906466c4725e41da18c4122f0f4.jpg',
      description: 'French luxury hair care combining science and sensoriality. Exceptional formulas for every hair concern.',
      problems: ['Hair thinning', 'Scalp sensitivity', 'Damaged hair', 'Frizz control'],
      why: 'Advanced research-backed formulations with proven results. Trusted by professionals worldwide for over 50 years.'
    },
    {
      id: 2,
      name: 'Olaplex',
      category: 'repair',
      image: 'https://readdy.ai/api/search-image?query=olaplex%20bond%20repair%20treatment%20products%20on%20pristine%20white%20surface%20with%20soft%20shadows%20clean%20minimal%20aesthetic%20professional%20hair%20care%20photography&width=600&height=400&seq=olaplex-brand-002&orientation=landscape',
      description: 'Revolutionary bond-building technology that repairs hair from the inside out.',
      problems: ['Chemical damage', 'Heat damage', 'Breakage', 'Split ends'],
      why: 'Patented technology that rebuilds broken disulfide bonds. Essential for chemically treated or damaged hair.'
    },
    {
      id: 3,
      name: 'Aveda',
      category: 'scalp',
      image: 'https://readdy.ai/api/search-image?query=aveda%20botanical%20hair%20care%20products%20with%20natural%20plant%20ingredients%20on%20clean%20white%20background%20soft%20lighting%20premium%20organic%20aesthetic%20professional%20photography&width=600&height=400&seq=aveda-brand-003&orientation=landscape',
      description: 'Plant-powered performance with naturally derived ingredients and pure flower and plant essences.',
      problems: ['Scalp imbalance', 'Oily scalp', 'Dry scalp', 'Environmental damage'],
      why: 'Botanical science meets high performance. Gentle yet effective formulas suitable for sensitive scalps.'
    },
    {
      id: 4,
      name: 'Redken',
      category: 'color',
      image: 'https://readdy.ai/api/search-image?query=redken%20professional%20hair%20color%20care%20products%20arranged%20on%20white%20surface%20modern%20clean%20aesthetic%20salon%20quality%20photography%20premium%20styling%20products&width=600&height=400&seq=redken-brand-004&orientation=landscape',
      description: 'Professional-grade formulas with protein science for strength and color protection.',
      problems: ['Color fading', 'Weak hair', 'Lack of shine', 'Dullness'],
      why: 'Protein-enriched formulas that strengthen while protecting color. Salon-exclusive professional quality.'
    },
    {
      id: 5,
      name: 'Moroccanoil',
      category: 'styling',
      image: 'https://readdy.ai/api/search-image?query=moroccanoil%20argan%20oil%20hair%20treatment%20products%20on%20clean%20white%20marble%20surface%20luxury%20aesthetic%20soft%20lighting%20premium%20hair%20care%20photography&width=600&height=400&seq=moroccanoil-brand-005&orientation=landscape',
      description: 'Argan oil-infused formulas that transform, nourish and condition all hair types.',
      problems: ['Frizz', 'Dryness', 'Unmanageable hair', 'Lack of shine'],
      why: 'Rich in antioxidants and vitamins. Instantly improves texture and adds luminous shine.'
    },
    {
      id: 6,
      name: 'Wella Professionals',
      category: 'color',
      image: 'https://readdy.ai/api/search-image?query=wella%20professional%20hair%20color%20products%20and%20treatments%20on%20pristine%20white%20surface%20clean%20minimal%20aesthetic%20salon%20quality%20photography%20premium%20care&width=600&height=400&seq=wella-brand-006&orientation=landscape',
      description: 'Innovative color technology and care systems trusted by stylists globally.',
      problems: ['Color damage', 'Brassiness', 'Tone correction', 'Color longevity'],
      why: 'Industry-leading color expertise with advanced care technology. Delivers vibrant, long-lasting results.'
    },
    {
      id: 7,
      name: 'Sachajuan',
      category: 'repair',
      image: 'https://readdy.ai/api/search-image?query=sachajuan%20scandinavian%20minimalist%20hair%20care%20products%20on%20white%20background%20clean%20nordic%20aesthetic%20premium%20professional%20photography%20simple%20elegant&width=600&height=400&seq=sachajuan-brand-007&orientation=landscape',
      description: 'Swedish hair care with Ocean Silk Technology for strength, shine and moisture balance.',
      problems: ['Brittle hair', 'Moisture loss', 'Lack of volume', 'Dull hair'],
      why: 'Scandinavian simplicity meets advanced technology. Clean formulas with exceptional performance.'
    },
    {
      id: 8,
      name: 'Philip Kingsley',
      category: 'scalp',
      image: 'https://readdy.ai/api/search-image?query=philip%20kingsley%20trichology%20scalp%20care%20products%20on%20clean%20white%20surface%20professional%20clinical%20aesthetic%20premium%20hair%20health%20photography&width=600&height=400&seq=kingsley-brand-008&orientation=landscape',
      description: 'Trichological expertise in scalp and hair health. Science-led formulations since 1968.',
      problems: ['Flaky scalp', 'Itchy scalp', 'Hair thinning', 'Scalp conditions'],
      why: 'Founded by a world-renowned trichologist. Clinically proven solutions for scalp and hair concerns.'
    }
  ];

  const filteredBrands = activeCategory === 'all' 
    ? brands 
    : brands.filter(brand => brand.category === activeCategory);

  const scrollToInquiry = () => {
    const inquirySection = document.getElementById('product-inquiry');
    if (inquirySection) {
      inquirySection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // SEO: Update page title and meta description
  useEffect(() => {
    document.title = 'Professional Hair Care Products | Muses Hair CWB';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional salon-grade hair care products including Kérastase, Olaplex, Aveda, Redken, Moroccanoil, Wella Professionals, Sachajuan, and Philip Kingsley. Expert solutions for scalp care, hair repair, styling, and color protection.');
    }
  }, []);

  // SEO: Add Schema.org JSON-LD
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": `${siteUrl}/products#webpage`,
          "url": `${siteUrl}/products`,
          "name": "Professional Hair Care Products | Muses Hair CWB",
          "description": "Professional salon-grade hair care products including Kérastase, Olaplex, Aveda, Redken, Moroccanoil, Wella Professionals, Sachajuan, and Philip Kingsley. Expert solutions for scalp care, hair repair, styling, and color protection.",
          "isPartOf": {
            "@type": "WebSite",
            "@id": `${siteUrl}/#website`,
            "url": siteUrl,
            "name": "Muses Hair CWB"
          },
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": siteUrl
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Products",
                "item": `${siteUrl}/products`
              }
            ]
          }
        },
        {
          "@type": "ItemList",
          "@id": `${siteUrl}/products#itemlist`,
          "name": "Professional Hair Care Brands",
          "description": "Carefully selected professional-grade hair care brands used at Muses Hair CWB",
          "itemListElement": [
            {
              "@type": "Product",
              "position": 1,
              "name": "Kérastase",
              "description": "French luxury hair care combining science and sensoriality. Exceptional formulas for every hair concern.",
              "brand": {
                "@type": "Brand",
                "name": "Kérastase"
              }
            },
            {
              "@type": "Product",
              "position": 2,
              "name": "Olaplex",
              "description": "Revolutionary bond-building technology that repairs hair from the inside out.",
              "brand": {
                "@type": "Brand",
                "name": "Olaplex"
              }
            },
            {
              "@type": "Product",
              "position": 3,
              "name": "Aveda",
              "description": "Plant-powered performance with naturally derived ingredients and pure flower and plant essences.",
              "brand": {
                "@type": "Brand",
                "name": "Aveda"
              }
            },
            {
              "@type": "Product",
              "position": 4,
              "name": "Redken",
              "description": "Professional-grade formulas with protein science for strength and color protection.",
              "brand": {
                "@type": "Brand",
                "name": "Redken"
              }
            },
            {
              "@type": "Product",
              "position": 5,
              "name": "Moroccanoil",
              "description": "Argan oil-infused formulas that transform, nourish and condition all hair types.",
              "brand": {
                "@type": "Brand",
                "name": "Moroccanoil"
              }
            },
            {
              "@type": "Product",
              "position": 6,
              "name": "Wella Professionals",
              "description": "Innovative color technology and care systems trusted by stylists globally.",
              "brand": {
                "@type": "Brand",
                "name": "Wella Professionals"
              }
            },
            {
              "@type": "Product",
              "position": 7,
              "name": "Sachajuan",
              "description": "Swedish hair care with Ocean Silk Technology for strength, shine and moisture balance.",
              "brand": {
                "@type": "Brand",
                "name": "Sachajuan"
              }
            },
            {
              "@type": "Product",
              "position": 8,
              "name": "Philip Kingsley",
              "description": "Trichological expertise in scalp and hair health. Science-led formulations since 1968.",
              "brand": {
                "@type": "Brand",
                "name": "Philip Kingsley"
              }
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    script.id = 'products-schema';
    document.head.appendChild(script);

    return () => {
      const existingScript = document.getElementById('products-schema');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6" style={{ backgroundColor: '#F3F0EB' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-light mb-6 text-gray-900" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Professional Products
          </h1>
          <p className="text-lg text-gray-700 leading-relaxed max-w-2xl mx-auto" style={{ fontFamily: 'Lato, sans-serif' }}>
            Every product in our salon is carefully selected for its proven effectiveness and quality. 
            We use only professional-grade brands that deliver real solutions for hair and scalp concerns.
          </p>
        </div>
      </section>

      {/* Why These Brands Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-light mb-6 text-gray-900" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Why We Choose These Brands
            </h2>
            <p className="text-base text-gray-600 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: 'Lato, sans-serif' }}>
              After 20 years of professional experience, I've learned that the right products make all the difference. 
              Each brand we use has been tested, trusted, and proven to deliver exceptional results.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-gray-50 rounded-lg">
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                <i className="ri-flask-line text-4xl" style={{ color: '#8B7355' }}></i>
              </div>
              <h3 className="text-xl font-medium mb-4 text-gray-900" style={{ fontFamily: 'Lato, sans-serif' }}>
                Science-Backed Formulas
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed" style={{ fontFamily: 'Lato, sans-serif' }}>
                Advanced research and proven ingredients that deliver measurable results for specific hair and scalp concerns.
              </p>
            </div>

            <div className="text-center p-8 bg-gray-50 rounded-lg">
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                <i className="ri-shield-check-line text-4xl" style={{ color: '#8B7355' }}></i>
              </div>
              <h3 className="text-xl font-medium mb-4 text-gray-900" style={{ fontFamily: 'Lato, sans-serif' }}>
                Professional Quality
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed" style={{ fontFamily: 'Lato, sans-serif' }}>
                Salon-exclusive formulations with higher concentrations of active ingredients than retail products.
              </p>
            </div>

            <div className="text-center p-8 bg-gray-50 rounded-lg">
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                <i className="ri-heart-pulse-line text-4xl" style={{ color: '#8B7355' }}></i>
              </div>
              <h3 className="text-xl font-medium mb-4 text-gray-900" style={{ fontFamily: 'Lato, sans-serif' }}>
                Proven Results
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed" style={{ fontFamily: 'Lato, sans-serif' }}>
                Trusted by professionals worldwide and tested on thousands of clients with consistent, reliable outcomes.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-12 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`px-6 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  activeCategory === category.id
                    ? 'text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
                style={{
                  backgroundColor: activeCategory === category.id ? '#8B7355' : undefined,
                  fontFamily: 'Lato, sans-serif'
                }}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12">
            {filteredBrands.map((brand) => (
              <div key={brand.id} className="bg-white rounded-lg overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow">
                <div className="w-full h-64">
                  <img 
                    src={brand.image} 
                    alt={brand.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-8">
                  <h3 className="text-3xl font-light mb-4 text-gray-900" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                    {brand.name}
                  </h3>
                  <p className="text-sm text-gray-600 mb-6 leading-relaxed" style={{ fontFamily: 'Lato, sans-serif' }}>
                    {brand.description}
                  </p>

                  <div className="mb-6">
                    <h4 className="text-xs font-semibold text-gray-900 mb-3 uppercase tracking-wide" style={{ fontFamily: 'Lato, sans-serif' }}>
                      Addresses These Concerns:
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {brand.problems.map((problem, index) => (
                        <span 
                          key={index}
                          className="px-3 py-1 bg-gray-100 text-gray-700 text-xs rounded-full"
                          style={{ fontFamily: 'Lato, sans-serif' }}
                        >
                          {problem}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="p-4 rounded-lg mb-6" style={{ backgroundColor: '#F3F0EB' }}>
                    <h4 className="text-xs font-semibold text-gray-900 mb-2 uppercase tracking-wide" style={{ fontFamily: 'Lato, sans-serif' }}>
                      Why We Use It:
                    </h4>
                    <p className="text-sm text-gray-700 leading-relaxed" style={{ fontFamily: 'Lato, sans-serif' }}>
                      {brand.why}
                    </p>
                  </div>

                  <button
                    onClick={scrollToInquiry}
                    className="w-full py-3 rounded-lg text-white text-sm font-medium transition-all hover:opacity-90 whitespace-nowrap cursor-pointer"
                    style={{ backgroundColor: '#8B7355', fontFamily: 'Lato, sans-serif' }}
                  >
                    Inquire About Products
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Product Recommendations Section */}
      <section className="py-20 px-6" style={{ backgroundColor: '#F3F0EB' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-light mb-6 text-gray-900" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Personalized Product Recommendations
          </h2>
          <p className="text-base text-gray-700 mb-8 leading-relaxed" style={{ fontFamily: 'Lato, sans-serif' }}>
            Not sure which products are right for your hair or scalp concern? During your consultation, 
            I'll assess your specific needs and recommend the most effective products for your home care routine.
          </p>
          <p className="text-sm text-gray-600 mb-10 leading-relaxed" style={{ fontFamily: 'Lato, sans-serif' }}>
            Professional products work best when paired with professional guidance. I'll show you exactly 
            how to use each product to maximize results and maintain the health of your hair and scalp between visits.
          </p>
          <button
            onClick={() => {
              const bookingSection = document.getElementById('booking-form');
              if (bookingSection) {
                bookingSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="px-8 py-3 rounded-lg text-white text-sm font-medium transition-all hover:opacity-90 whitespace-nowrap cursor-pointer"
            style={{ backgroundColor: '#8B7355', fontFamily: 'Lato, sans-serif' }}
          >
            Book a Consultation
          </button>
        </div>
      </section>

      {/* Product Inquiry Section */}
      <section id="product-inquiry" className="py-20 px-6 bg-white">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-light mb-6 text-gray-900" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Product Inquiry
            </h2>
            <p className="text-base text-gray-600 leading-relaxed" style={{ fontFamily: 'Lato, sans-serif' }}>
              Interested in purchasing professional products for home care? Fill out the form below and 
              I'll get back to you with availability and recommendations.
            </p>
          </div>

          <form 
            id="product-inquiry-form"
            data-readdy-form
            className="space-y-6"
            onSubmit={async (e) => {
              e.preventDefault();
              const form = e.currentTarget;
              const formData = new FormData(form);
              const submitButton = form.querySelector('button[type="submit"]') as HTMLButtonElement;
              const successMessage = document.getElementById('inquiry-success-message');

              // Validate required fields
              const name = formData.get('name') as string;
              const email = formData.get('email') as string;
              const phone = formData.get('phone') as string;

              if (!name || !email || !phone) {
                alert('Please fill in all required fields');
                return;
              }

              // Email validation
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!emailRegex.test(email)) {
                alert('Please enter a valid email address');
                return;
              }

              // Disable submit button
              if (submitButton) {
                submitButton.disabled = true;
                submitButton.textContent = 'Sending...';
              }

              try {
                const response = await fetch('https://readdy.ai/api/public/form/submit/product-inquiry-form-001', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                  },
                  body: new URLSearchParams(formData as any).toString()
                });

                if (response.ok) {
                  form.reset();
                  if (successMessage) {
                    successMessage.classList.remove('hidden');
                    setTimeout(() => {
                      successMessage.classList.add('hidden');
                    }, 5000);
                  }
                } else {
                  alert('Something went wrong. Please try again.');
                }
              } catch (error) {
                alert('Something went wrong. Please try again.');
              } finally {
                if (submitButton) {
                  submitButton.disabled = false;
                  submitButton.textContent = 'Send Inquiry';
                }
              }
            }}
          >
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" style={{ fontFamily: 'Lato, sans-serif' }}>
                Name *
              </label>
              <input
                type="text"
                id="name"
                name="name"
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-opacity-50"
                style={{ fontFamily: 'Lato, sans-serif', focusRingColor: '#8B7355' }}
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" style={{ fontFamily: 'Lato, sans-serif' }}>
                Email *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-opacity-50"
                style={{ fontFamily: 'Lato, sans-serif', focusRingColor: '#8B7355' }}
              />
            </div>

            <div>
              <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2" style={{ fontFamily: 'Lato, sans-serif' }}>
                Phone *
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-opacity-50"
                style={{ fontFamily: 'Lato, sans-serif', focusRingColor: '#8B7355' }}
              />
            </div>

            <div>
              <label htmlFor="product-interest" className="block text-sm font-medium text-gray-700 mb-2" style={{ fontFamily: 'Lato, sans-serif' }}>
                Which products are you interested in?
              </label>
              <textarea
                id="product-interest"
                name="product-interest"
                rows={4}
                maxLength={500}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-opacity-50 resize-none"
                style={{ fontFamily: 'Lato, sans-serif', focusRingColor: '#8B7355' }}
                placeholder="Tell me about your hair concerns and which brands or products interest you..."
              ></textarea>
              <p className="text-xs text-gray-500 mt-1" style={{ fontFamily: 'Lato, sans-serif' }}>Maximum 500 characters</p>
            </div>

            <button
              type="submit"
              className="w-full py-4 rounded-lg text-white text-sm font-medium transition-all hover:opacity-90 whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#8B7355', fontFamily: 'Lato, sans-serif' }}
            >
              Send Inquiry
            </button>

            <div id="inquiry-success-message" className="hidden p-4 rounded-lg text-center" style={{ backgroundColor: '#F3F0EB' }}>
              <p className="text-sm font-medium text-gray-900" style={{ fontFamily: 'Lato, sans-serif' }}>
                Thank you for your inquiry! I'll get back to you within 24 hours with product information and recommendations.
              </p>
            </div>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Products;